// src/services/serviceService.ts
import api from '../api/axiosClient';

export interface Service {
  id: number;
  name: string;
  description?: string;
}

export const getServices = async (): Promise<Service[]> => {
  const response = await api.get<Service[]>('/Service');
  return response.data;
};

export const getService = async (id: number): Promise<Service> => {
  const response = await api.get<Service>(`/Service/${id}`);
  return response.data;
};

export const createService = async (service: Omit<Service, 'id'>): Promise<Service> => {
  const response = await api.post<Service>('/Service', service);
  return response.data;
};

export const updateService = async (id: number, service: Omit<Service, 'id'>): Promise<Service> => {
  const response = await api.put<Service>(`/Service/${id}`, service);
  return response.data;
};

export const deleteService = async (id: number): Promise<void> => {
  await api.delete(`/Service/${id}`);
};

export const checkServiceUsage = async (id: number): Promise<{ isUsed: boolean; bookingCount: number }> => {
  try {
    const response = await api.get<{ isUsed: boolean; bookingCount: number }>(`/Service/${id}/usage`);
    return response.data;
  } catch (error) {
    // If endpoint doesn't exist, assume it's safe to delete
    return { isUsed: false, bookingCount: 0 };
  }
};
